"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  // Options.jsx
  items_per_page: '/ orrialde',
  jump_to: '-ra joan',
  jump_to_confirm: 'baieztatu',
  page: 'Orrialde',
  // Pagination.jsx
  prev_page: 'Aurreko orrialdea',
  next_page: 'Hurrengo orrialdea',
  prev_5: 'aurreko 5 orrialde',
  next_5: 'hurrengo 5 orrialde',
  prev_3: 'aurreko 3 orrialde',
  next_3: 'hurrengo 3 orrialde',
  page_size: 'orrien tamaina'
};
exports.default = _default;